// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"e6f70da9","421":"83571726"}[chunkId] + ".chunk.css";
};